import { render } from "./FeaturedProductSingle.vue?vue&type=template&id=7810e0a1&scoped=true"
import script from "./FeaturedProductSingle.vue?vue&type=script&lang=js"
export * from "./FeaturedProductSingle.vue?vue&type=script&lang=js"

import "./FeaturedProductSingle.vue?vue&type=style&index=0&id=7810e0a1&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7810e0a1"]])

export default __exports__